/**
 * @module services/convertFailureLog
 * @description convert() 异常兜底的可观测上下文（开发环境 console，避免配置丢失静默）
 */

import type { TChartType } from '@dbl/core/chart';

export interface IConvertFailureLogContext {
  chartType: TChartType | string | undefined;
  errorMessage: string;
  errorName: string;
}

/** 从 unknown 提取可序列化的错误摘要 */
export function summarizeConvertError(error: unknown): {
  errorMessage: string;
  errorName: string;
} {
  if (error instanceof Error) {
    return {
      errorMessage: error.message,
      errorName: error.name,
    };
  }
  return {
    errorMessage: String(error),
    errorName: 'UnknownError',
  };
}

/**
 * 结构化记录 convert 失败（使用 console.warn，便于 devtools 过滤且避免监控误报为 error）
 */
export function logConvertFailure(
  chartType: TChartType | string | undefined,
  error: unknown,
): IConvertFailureLogContext {
  const { errorMessage, errorName } = summarizeConvertError(error);
  const context: IConvertFailureLogContext = {
    chartType,
    errorMessage,
    errorName,
  };

  if (process.env.NODE_ENV !== 'test') {
    // eslint-disable-next-line no-console
    console.warn(
      '[ChartSettingsV2] convert failed, fallback to empty customizeSetting',
      context,
      error,
    );
  }

  return context;
}

